// THIS FUNCTION checks if the object has some value that is a empty string or null

export default function isEmpty(object) {
  return !Object.values(object).some(x => (x !== null && x !== ''));
}